export const colors = {
    primary: "#1E99D7",
    headings: "#0D568E",
}